import {
  CANCEL,
  CONFIRM,
  FINISH,
  MFA_SETTINGS_RECOVERY_CODES_CONFIRM_SUBTITLE,
  MFA_SETTINGS_RECOVERY_CODES_TITLE,
  RECOVERY_OTP_TEXT_FILE_NAME,
  RECOVERY_OTP_TEXT_FILE_TITLE,
} from '../../constants/ui.labels'
import Modal, { Dialog } from '@talkdesk/cobalt-react-modal'
import { Portal } from '@talkdesk/cobalt-react-portal-provider'
import ConfirmDialog from './ConfirmDialog'
import { RecoveryOTPConfiguration } from 'mfa'
import { Center } from '../Wrappers/index'
import Flex from '@talkdesk/cobalt-react-flex'
import IconWithProvider from '@talkdesk/cobalt-react-icon'

const renderCodes = (otpList, onDismiss) => (
  <Center>
    <RecoveryOTPConfiguration
      otpList={otpList}
      onConfirm={onDismiss}
      requiresConfirm={false}
      confirmText={FINISH}
      fileTitle={RECOVERY_OTP_TEXT_FILE_TITLE}
      fileName={RECOVERY_OTP_TEXT_FILE_NAME}
    />
  </Center>
)

const renderConfirm = (
  onDismiss,
  onConfirm,
  errorMessage,
  isRenewInProgress,
) => (
  <ConfirmDialog
    onDismiss={onDismiss}
    onConfirm={onConfirm}
    dismissText={CANCEL}
    confirmText={CONFIRM}
    title={MFA_SETTINGS_RECOVERY_CODES_TITLE}
    subtitle={MFA_SETTINGS_RECOVERY_CODES_CONFIRM_SUBTITLE}
    isCancelDisabled={isRenewInProgress}
    isConfirmDisabled={isRenewInProgress}
    errorMessage={errorMessage}
  />
)

const RecoveryCodesRenewConfirm = ({
  onDismiss,
  onConfirm,
  errorMessage,
  isRenewInProgress,
  otpList,
}) => (
  <Portal>
    <Modal size='small' visible>
      <Flex alignX='end' paddingBottom='2'>
        <IconWithProvider
          name='close'
          size='small'
          color='white'
          onClick={onDismiss}
        />
      </Flex>
      <Dialog>
        <Flex scrollable padding={['3', '5', '6']}>
          {otpList
            ? renderCodes(otpList, onDismiss)
            : renderConfirm(
                onDismiss,
                onConfirm,
                errorMessage,
                isRenewInProgress,
              )}
        </Flex>
      </Dialog>
    </Modal>
  </Portal>
)

export default RecoveryCodesRenewConfirm
